<template>
  <component :is="tag" v-html="sanitizedContent" />
</template>

<script setup lang="ts">
/**
 * Безопасный вывод HTML: контент санитизируется через DOMPurify на клиенте.
 * Использовать для контента из i18n (доверенный JSON) и любого другого HTML.
 */
const props = withDefaults(
  defineProps<{
    content?: string | null
    tag?: string
  }>(),
  { tag: 'div' }
)

const { sanitize } = useSanitizeHtml()
const sanitizedContent = computed(() => sanitize(props.content))
</script>
